var $f9507c2d404ed689$exports = {};
$f9507c2d404ed689$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Seletor de cores`,
    "colorSwatch": `amostra de cores`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Controle deslizante 2D`
};


export {$f9507c2d404ed689$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
